import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactPanelActivityComponent } from './contact-panel-activity.component';
import { WidgetsModule } from '../../../widgets/widgets.module';

@NgModule({
    imports: [
        CommonModule,
        WidgetsModule
    ],
    declarations: [
        ContactPanelActivityComponent,
    ],
    exports: [
        ContactPanelActivityComponent,
    ],
    providers: [
    ]
})
export class ContactPanelActivityModule {
}
